import React, { useState } from 'react'
import PageHeader from '../../Component/BasicComponents/HeaderBreadCrumbs';
import BasicDataTable from '../../Component/BasicComponents/BasicDataTable';
import { useLocation, useNavigate } from 'react-router-dom';
import RouteModal from '../../Component/BasicComponents/Modal/RouteModal';
import MtpEmployeeDetailsCard from './components/MtpEmployeeDetailsCard';
import { RiPencilFill } from "react-icons/ri";
import { IoMdEye } from "react-icons/io";
import { IoMdHome } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";
import {FaEye } from 'react-icons/fa';
import {useMtpDayBeatTown, useMTPDayByIdData, useMTPDayCustomers } from './hooks/useMTP';


const MtpListColumns = (handleMtpView: (row: any) => void, handleMtpCustomerView: (row: any) => void ,handleMtpCustomerTownView:(row:any)=>void) => [
    {
        name: "MTP Day Date",
        selector: (row: { MtpDayDate: string }) => row.MtpDayDate || '-',
        sortable: true,
        width: '150px',
        wrap: true
    },
    {
        name: "Week Day",
        selector: (row: { Weekday: string | number }) => row.Weekday || '-',
        sortable: true,
        width: '120px',
        wrap: true,
        center:true
    },

    {
        name: "Working",
        selector: (row: { Working: string | number }) => row?.Working || '-', // (depend by backend)
        sortable: true,
        width: '120px',
        wrap: true
    },

    
    {
    name: "Customer",
     cell: (row: { CustomerCount: any }) => <button
    onClick={() => handleMtpCustomerView(row)}
    style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    border: "none",
    borderRadius: "8px",
    padding: "6px 12px",
    backgroundColor: "#2e8dd3",
    color: "#fff",
    fontSize: "14px",
    cursor: "pointer",
  }}
>
  <IoMdEye style={{ fontSize: "16px",fill: "#fff"}} />
  {row?.CustomerCount}
</button>,
        sortable: true,
        width: '120px',
        wrap: true
    },

    {
        name: "Town",
        cell: (row: { CustomerCount: any }) =><button
            onClick={() => handleMtpCustomerTownView(row)}
            className="btn btn-primary"
            style={{
            display: "flex",
             alignItems: "center",
             justifyContent: "center",
             gap: "6px",
             border: "none",
             borderRadius: "8px",
             padding: "4px 12px",
             backgroundColor: "#2e8dd3",
             color: "#fff",
             fontSize: "14px",
             cursor: "pointer",
            
            }}
        >
            <IoMdHome style={{ fill: "#fff", fontSize: '16px' }} />{row?.CustomerCount}
        </button>, // (depend by backend)
        sortable: true,
        width: '130px',
        center:true
    },

    {
        name: "Calls",
        selector: (row: { Calls: string | number }) => `${row?.Calls}` || '-',
        sortable: true,
        width: '120px',
        wrap: true
    },
    {
        name: "FW Count",
        selector: (row: { FWCount: string | number }) => `${row?.FWCount}` || '-',
        sortable: true,
        width: '150px',
        wrap: true
    },
    {
        name: "NCA Count",
        selector: (row: { NCACount: string | number }) => `${row?.NCACount}` || '-',
        sortable: true,
        width: '150px',
        wrap: true
    },
    {
        name: "Doctor",
        selector: (row: { Doctor: string | number }) => `${row?.Doctor}` || '-', // (depend by backend)
        sortable: true,
        width: '120px',
        wrap: true
    },
    {
        name: "Chemist",
        selector: (row: { Chemist: string | number }) => `${row?.Chemist}` || '-', // (depend by backend)
        sortable: true,
        width: '120px',
        wrap: true
    },
    {
        name: "Stockist",
        selector: (row: { Stockist: string | number }) => `${row?.Stockist}` || '-', // (depend by backend)
        sortable: true,
        width: '120px',
        wrap: true
    },
    {
        name: "Actions",
        cell: (row: any) => (
            <div className="d-flex align-items-center">
                <div className="d-flex align-items-center" style={{ marginLeft: 10 }}>
                    <button
                        onClick={() => handleMtpView(row)}
                        className="btn btn-primary"
                        style={{ borderRadius: "20px", padding: "2px", width: "70px", backgroundColor: '#2e8dd3' }}
                    >
                        <FaEye style={{ fill: "#fff" }} />View
                    </button>
                </div>
            </div>
        ),
        center:true
    },

]


const CustomerViewColumns = (handleCustomerViewProfile: (row: any) => void) => [
    {
        name: "Customer name",
        selector: (row: { customerName: string }) => row?.customerName || '-', // (depend by backend)
        sortable: true,
    },
    {
        name: "Action",
        cell: (row: { Customer: any }) => <button
            onClick={() => handleCustomerViewProfile(row)}
            className="btn btn-primary"
            style={{ borderRadius: "10px", paddingLeft: "5px", paddingRight: "5px", width: "auto", backgroundColor: '#2e8dd3' }}
        >
            <IoMdEye style={{ fill: "#fff" }} />{'View Profile'}
        </button>, // (depend by backend)
        sortable: true,
    }
]

const CustomerTownViewColumns=[ 
    {
        name: "Town Name",
        selector: (row: {TownName: string }) => row?.TownName || '-', 
        sortable: true,
    },

]

const MtpDetailView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { mtpRowData } = location?.state || {};
    const [MtpDayId,setMtpDayId] = useState<number |undefined>(undefined);
    const [MtpDayId_forTown,setMtpDayId_forTown] = useState<number |undefined>(undefined);

    const [paginationStates, setPaginationStates] = useState({
        page: 1,
        limit: 10,
        mtpId: mtpRowData?.MtpId,
    })
    
      const {isLoading,isSuccess,data:MtpDayCustomersData} = useMTPDayCustomers({enable: !!MtpDayId, mtpDayId:MtpDayId as number})
      const {isLoading:MtpDayBeatTownisLoading,isSuccess:MtpDayBeatTownIsSuccess,data:MtpDayBeatTownData} = useMtpDayBeatTown({enable: !!MtpDayId_forTown,agendaControlType:'',mtpDayId:MtpDayId_forTown as number})

    const { data: mtpDayByIdData,isLoading:mtpDayByIdIsLoading } = useMTPDayByIdData({
        enable: paginationStates?.mtpId ? true : false, params: {
            limit: paginationStates.limit,
            page: paginationStates.page,
            mtpId: paginationStates.mtpId,
        }
    })

    // console.log('mtpDayByIdData====>',mtpDayBydData);

    const [customerViewModal, setCustomerViewModal] = useState<boolean>(false);
    const [customerViewTownModal, setCustomerTownViewModal] = useState<boolean>(false);

    const handleMtpView = (row: any) => {
        navigate('/mtpDayTourPlan', { state: { mtpDayRowData: row } })
    }

    const handleMtpCustomerView = (row: any) => {
        setMtpDayId(row.MtpDayId);
        setCustomerViewModal(true)
    }

    const handleMtpCustomerTownView=(row:any)=>{
        setMtpDayId_forTown(row.MtpDayId)   
        setCustomerTownViewModal(true);
    }

    const handleCustomerViewProfile = (row: any) => {
        console.log('row',row);
        navigate('/customer/customerProfile', { state: {outletId:row.OutletOrgId} })
        setCustomerViewModal(true)
    }
    const handlePagination = (pageNo: number) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                page: pageNo,
            };
        });
    };

    const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                page: pageNo,
                limit: limit,
            };
        });
    };



    return (
        <div
            className="p-4"
        >
            <PageHeader
                title="MTP Detail view"
                buttons={[
                    // {
                    //     label: "Excel",
                    //     onClick: () => alert("Action 2 clicked"),
                    //     color: "#43B9B2",
                    // },
                    // {
                    //     label: "CSV",
                    //     onClick: () => alert("Action 3 clicked"),
                    //     color: "#43B9B2",
                    // },

                ]}
            />
            <MtpEmployeeDetailsCard data={{
                EmployeeName: mtpDayByIdData?.data?.MTPData?.EmployeeName,
                EmployeeCode: mtpDayByIdData?.data?.MTPData?.EmployeeCode,
                EmployeeEmail: mtpDayByIdData?.data?.MTPData?.EmployeeEmail,
                PositionName: mtpDayByIdData?.data?.MTPData?.PositionName,
                Month: mtpDayByIdData?.data?.MTPData?.Month,
                GradeName: mtpDayByIdData?.data?.MTPData?.GradeName,
                ReportingToPositionName: mtpDayByIdData?.data?.MTPData?.ReportingToPositionName,
                TotalVisits: mtpDayByIdData?.data?.MTPData?.TotalVisits,
                OutletsCovered: mtpDayByIdData?.data?.MTPData?.OutletsCovered,
                MtpStatus:mtpDayByIdData?.data?.MTPData?.MtpStatus ? mtpDayByIdData?.data?.MTPData?.MtpStatus.charAt(0).toUpperCase() + mtpDayByIdData?.data?.MTPData?.MtpStatus.slice(1):"",
                EmployeePhone: mtpDayByIdData?.data?.MTPData?.EmployeePhone,
            }} />
            <div style={{ height: 15 }} />
            <BasicDataTable
                dynamicHeightOnRowsPerPage={true}
                paginationTotalRows={mtpDayByIdData?.data?.Pagination?.TotalCount || 0}
                onChangePage={(pageNo: number) => { handlePagination(pageNo); }}
                onChangeRowsPerPage={(newPerPage: any, page: any) => {
                    handleonChangeRowsPerPage(newPerPage, page)
                }}
                Title="MTP Day Data"
                search={false}
                columns={MtpListColumns(handleMtpView, handleMtpCustomerView,handleMtpCustomerTownView)}
                data={mtpDayByIdData?.data?.MTPDayData || []}
                showSpinner={mtpDayByIdIsLoading}

            />

            <RouteModal
                isOpen={customerViewModal}
                toggle={() => { setCustomerViewModal(!customerViewModal) }}
                size="md"
                content={<>
                    <RxCross2 onClick={() => { setCustomerViewModal(false) }} size={20} style={{ fill: "#e2e2e2", position: 'absolute', top: 3, right: 10, cursor: 'pointer' }} />
                    <div className="row mb-0">
                        <BasicDataTable
                            Title="MTP Customers"
                            pagination={false}
                            search={false}
                            columns={CustomerViewColumns(handleCustomerViewProfile)}
                            data={(!isLoading && isSuccess && MtpDayCustomersData?.formatedData) || []}
                        />
                    </div>
                </>
                }
            />

            <RouteModal
                isOpen={customerViewTownModal}
                toggle={() => {setCustomerTownViewModal(!customerViewTownModal) }}
                size="md"
                content={
                <>
                    <RxCross2 onClick={() => {setCustomerTownViewModal(false) }} size={20} style={{fill: "#e2e2e2", position: 'absolute', top: 3, right: 10, cursor: 'pointer' }} />
                    <div className="row mb-0">
                        <BasicDataTable
                          Title="Towns"
                          pagination={false}
                            search={false}
                            columns={CustomerTownViewColumns}
                            data={(!MtpDayBeatTownisLoading && MtpDayBeatTownIsSuccess && MtpDayBeatTownData?.formatedData) ||[]}
                        />
                    </div>
                </>

                }
            />
        </div>
    )
}

export default MtpDetailView